module.exports = __webpack_public_path__ + "static/kaseyheaderfigmaps-dca358fd360ad615acfed1a4db37cf94.png";